import { useContext, useMemo, useCallback } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { TIMESHEET_GROUP_BY_OPTIONS_ENUM } from '@ubeya/shared/constants';
import { createPartialNameCellRenderer, createNameFieldComparator } from 'timeSheet/utils';

const useLastNameColumn = ({ groupBy }) => {
  const { t } = useContext(ConfigContext);

  const valueGetter = useCallback((params) => params.data?.employee?.lastName?.toLowerCase() || '', []);
  const cellRenderer = useMemo(() => createPartialNameCellRenderer({ groupBy, showOnlyFirstName: false }), [groupBy]);
  const comparator = useMemo(
    () =>
      createNameFieldComparator({
        fieldName: 'lastName',
        isGroupedByEmployee: groupBy === TIMESHEET_GROUP_BY_OPTIONS_ENUM.EMPLOYEE
      }),
    [groupBy]
  );

  return useMemo(
    () => ({
      field: 'lastName',
      headerName: t('lastName'),
      width: 250,
      initialHide: true,
      cellClass: 'justify-start',
      valueGetter,
      cellRenderer,
      comparator
    }),
    [t, valueGetter, cellRenderer, comparator]
  );
};

export default useLastNameColumn;
